import React, { useState } from "react";
import { Form, Radio, Row, Tooltip } from "antd";
import Loader from "@/components/Loader";
import { SaveOutlined, ProjectOutlined, SettingOutlined } from "@ant-design/icons/lib";
import { useRootSelector } from "@/infrastructure/hooks";
import { BacktestSel } from "@/features/backtest";
import { services } from "./services";
import { SetupContext } from "./hooks";

import styles from "./styles.less";

export default () => {
  const [form] = Form.useForm();
  const [page, setPage] = useState("setup");
  const isBtMetaLoading = useRootSelector(BacktestSel.isBtMetaLoading);

  return (
    <SetupContext.Provider value={{ form, page, setPage }}>
      <Row className={styles.content}>
        <Radio.Group className={styles.setupButtons} value={page} onChange={e => setPage(e.target.value)}>
          <Tooltip placement={"topLeft"} title={"Backtest your strategy"}>
            <Radio.Button className={styles.radioLeftButton} type={"dashed"} value={"setup"}>
              <SettingOutlined /> Set-up
            </Radio.Button>
          </Tooltip>
          <Tooltip placement={"topLeft"} title={"Analyze backtest's results"}>
            <Radio.Button type={"dashed"} value={"results"}>
              <ProjectOutlined /> Results
            </Radio.Button>
          </Tooltip>
          <Tooltip placement={"topRight"} title={"Load previous results"}>
            <Radio.Button className={styles.radioRightButton} type={"dashed"} value={"snapshot"}>
              <SaveOutlined /> Load/Save
            </Radio.Button>
          </Tooltip>
        </Radio.Group>
        {isBtMetaLoading ? <Loader /> : React.createElement(services[page])}
      </Row>
    </SetupContext.Provider>
  );
};
